import React from 'react';
import { Link } from 'react-router-dom';
import Avatar from 'react-avatar';

const NavBar = ({ user }) => {
  return (
    <React.Fragment>
      <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">
        <button
          id="sidebarToggleTop"
          className="btn btn-link d-md-none rounded-circle mr-3"
        >
          <i className="fa fa-bars" />
        </button>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item dropdown no-arrow">
            <Link
              className="nav-link dropdown-toggle"
              to="#"
              id="userDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                Admin
              </span>
              <Avatar
                color={Avatar.getRandomColor('sitebase', [
                  'red',
                  'green',
                  'blue',
                ])}
                size="32"
                name={user.name}
                round={true}
              />
            </Link>
            {user && (
              <React.Fragment>
                <div
                  className="dropdown-menu dropdown-menu-right shadow animated--grow-in"
                  aria-labelledby="userDropdown"
                >
                  <Link className="dropdown-item" to="/admin/profile">
                    <i className="fa fa-user fa-sm fa-fw mr-2 text-gray-400" />
                    {user.email}
                  </Link>
                  <div className="dropdown-divider" />

                  <Link className="dropdown-item" to="/logout">
                    <i className="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400" />
                    Logout
                  </Link>
                </div>
              </React.Fragment>
            )}
          </li>
        </ul>
      </nav>
    </React.Fragment>
  );
};

export default NavBar;
